import { Add, ArrowForwardIos, GridView } from "@mui/icons-material";
// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
// import BasicTable from "../../Components/Table/BasicTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
// import { getAllUsers, reset } from "../../Redux/UserSlice/UserSlice";
import { Link, useLocation, useParams } from "react-router-dom";
import { Outlet } from "react-router-dom";
import CreateUser from "./CreateUser";
import ModalContainer from "../../Components/Modal/ModalContainer";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../Redux/modalSlice";
import { useEffect } from "react";
import { getSingleUsers, reset } from "../../Redux/UserSlice/UserSlice";

const Users = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    const { parent } = useParams();

    const { singleUser } = useSelector((state) => state.users);

    const user = singleUser?.data;

    useEffect(() => {
        if (parent) {
            const GETUSERINFO = async () => {
                await dispatch(getSingleUsers(parent));
                await dispatch(reset());
            };
            GETUSERINFO();
        }
    }, [dispatch, parent]);

    return (
        <>
            <ModalContainer>
                <CreateUser />
            </ModalContainer>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    {parent ? (
                        <>
                            <Link to="">
                                <span sx={{ textColor: "primary" }}>
                                    {path + " "}
                                </span>
                            </Link>
                            <ArrowForwardIos></ArrowForwardIos>
                            <span> childrens </span>
                            {user && (
                                <>
                                    <ArrowForwardIos></ArrowForwardIos>
                                    <span>{user?.name}</span>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <span> {path} </span>
                        </>
                    )}
                </div>
                <ButtonTable
                    startIcon={<Add />}
                    onClick={() => dispatch(openModal())}
                >
                    New
                </ButtonTable>
            </HeaderTable>

            <Outlet />
        </>
    );
};

export default Users;
